import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./Control.module.sass";
import cn from "classnames";
import Icon from "../../../../../components/Icon";
import OutsideClickHandler from "react-outside-click-handler";
import { downloadContract } from "../../../../../services/contract.service";
import { toast } from "react-toastify";

const Control = ({ className, item }) => {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);

  const getNextStep = () => {
    const progressData = item?.progression?.entreprise;
    const studentData = item?.progression?.etudiant;

    // Vérifier si l'étudiant a rempli ses informations
    const studentInfosFilled = studentData?.infos_remplies;

    // Si l'étudiant n'a pas rempli ses infos, pas d'accès aux étapes entreprise
    if (!studentInfosFilled) {
      return null;
    }

    // Déterminer la prochaine étape en fonction de la progression entreprise
    if (!progressData) {
      return 1;
    }

    // Étape 1: Informations de base (infos_remplies)
    if (!progressData.infos_remplies) {
      return 1;
    }

    // Étape 2: Création du contrat (contrat_cree)
    if (progressData.infos_remplies && !progressData.contrat_cree) {
      return 2;
    }

    // Étape 3: Assignation des tuteurs (tuteur_assigne)
    if (progressData.infos_remplies && progressData.contrat_cree && !progressData.tuteur_assigne) {
      return 3;
    }

    // Étape 4: Validation du contrat
    if (progressData.infos_remplies && progressData.contrat_cree && progressData.tuteur_assigne && !progressData.valide) {
      return 4;
    }

    // Si tout est validé
    if (progressData.valide) {
      return 'completed';
    }

    return 1;
  };

  const getStepLabel = () => {
    const nextStep = getNextStep();
    
    if (nextStep === null) {
      return "En attente de l'élève";
    }
    if (nextStep === 'completed') {
      return "Dossier complet";
    }
    
    const labels = {
      1: "Compléter les informations",
      2: "Vérifier le contrat",
      3: "Assigner un tuteur",
      4: "Valider le dossier"
    };
    
    return labels[nextStep] || "Compléter le dossier";
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    const nextStep = getNextStep();
    
    if (nextStep === null) {
      toast.info("En attente que l'élève complète ses informations");
      return;
    }
    
    if (nextStep === 'completed') {
      navigate(`/company/folder/${item.id}/view`);
      return;
    }
    
    if (nextStep === 4) {
      navigate(`/company/folder/${item.id}/validation`);
      return;
    }
    
    navigate(`/company/folder/${item.id}/${nextStep}`);
    setVisible(false);
  };

  const handleDownloadContract = (e) => {
    e.stopPropagation();
    const contract = item.expand?.contract_id;
    
    if (contract?.document) {
      downloadContract({ ...contract, fileField: 'document' });
    } else {
      toast.error("Aucun contrat disponible");
    }
    setVisible(false);
  };

  const handleDownloadConvention = (e) => {
    e.stopPropagation();
    const contract = item.expand?.contract_id;
    
    if (contract?.convention) {
      downloadContract({ ...contract, fileField: 'convention' });
    } else {
      toast.error("Aucune convention disponible");
    }
    setVisible(false);
  };

  const nextStep = getNextStep();
  const isWaitingStudent = nextStep === null;
  const isCompleted = nextStep === 'completed';

  const actions = [
    {
      title: getStepLabel(),
      icon: isWaitingStudent ? "clock" : (isCompleted ? "check" : "edit"),
      action: handleEdit,
      disabled: isWaitingStudent,
    },
    {
      title: "Télécharger le contrat",
      icon: "download",
      action: handleDownloadContract,
    },
    {
      title: "Télécharger la convention",
      icon: "download",
      action: handleDownloadConvention,
    },
  ];

  return (
    <OutsideClickHandler onOutsideClick={() => setVisible(false)}>
      <div className={cn(styles.control, className)}>
        <button
          className={cn(styles.button, { [styles.active]: visible })}
          onClick={(e) => {
            e.stopPropagation();
            setVisible(!visible);
          }}
        >
          <Icon name="more-horizontal" size="20" />
        </button>
        <div className={cn(styles.body, { [styles.visible]: visible })}>
          {actions.map((action, index) => (
            <button
              className={cn(styles.action, { [styles.disabled]: action.disabled })}
              key={index}
              onClick={action.action}
              disabled={action.disabled}
            >
              <Icon name={action.icon} size="20" />
              {action.title}
            </button>
          ))}
        </div>
      </div>
    </OutsideClickHandler>
  );
};

export default Control;
